module.exports = __webpack_public_path__ + "img/bank.1893263a.svg";